import { CollectionResult } from "~src/types/common";
import { ApiTypes, api } from "../common";
import {
  AddBoardPayload,
  Board,
  PinnedAd,
  PinnedAdsFilters,
  PinnedBrand,
} from "~src/types/creativeCenter";

export type SavedAd = {
  id: number;
  board_id: number;
  fb_ad_id: string;
  created_on: string;
  updated_on: string;
  fb_ad: string;
};

const CREATIVE_CENTER_PATHS: ApiTypes.API = {
  boards: {
    path: "api/creative/board",
    method: ApiTypes.HTTPMethod.GET,
  },
  createBoard: {
    path: "api/creative/board/",
    method: ApiTypes.HTTPMethod.POST,
  },
  pinAd: {
    path: "/api/creative/pin-tr-fb-ad/",
    method: ApiTypes.HTTPMethod.POST,
  },
  pinnedBrands: {
    path: "api/creative/pinned-brands",
    method: ApiTypes.HTTPMethod.GET,
  },
  pinnedAds: {
    path: "api/creative/board-ads/",
    method: ApiTypes.HTTPMethod.GET,
  },
};

export const pinAd = async (
  board_id: number | null | undefined,
  fb_ad_id: string,
) => {
  const endpoint = CREATIVE_CENTER_PATHS.pinAd;
  const response = await api<SavedAd>({
    method: endpoint.method,
    url: endpoint.path,
    data: { board_id, fb_ad_id },
  });

  return response.data;
};

export const fetchMyBoards = async (page = 1, pageSize = 20) => {
  const endpoint = CREATIVE_CENTER_PATHS.boards;
  const response = await api<CollectionResult<Board>>({
    method: endpoint.method,
    url: endpoint.path,
    params: { page, pageSize },
  });

  return response.data;
};

export const fetchMyPinnedBrands = async (page = 1, pageSize = 20) => {
  const endpoint = CREATIVE_CENTER_PATHS.pinnedBrands;
  const response = await api<PinnedBrand[]>({
    method: endpoint.method,
    url: endpoint.path,
    params: { page, pageSize },
  });

  return response.data;
};

export const fetchPinnedAds = async (
  filters?: PinnedAdsFilters,
  page = 1,
  pageSize = 20,
) => {
  const endpoint = CREATIVE_CENTER_PATHS.pinnedAds;
  const response = await api<CollectionResult<PinnedAd>>({
    method: endpoint.method,
    url: endpoint.path,
    params: {
      page,
      pageSize,
      board_ids: filters?.boardIds,
      platforms: filters?.platforms,
      display_formats: filters?.format,
      ordering: filters?.sort,
      page_ids: filters?.brandIds,
    },
  });

  return response.data;
};

export const addNewBoard = async (payload: AddBoardPayload) => {
  const endpoint = CREATIVE_CENTER_PATHS.createBoard;

  const response = await api<Board>({
    method: endpoint.method,
    url: endpoint.path,
    data: payload,
  });

  return response.data;
};
